import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PositionHistoryData } from './types'

export type PositionsState = {
  data: PositionHistoryData
  fetching: boolean
  hasError: boolean
}

export const initialState: PositionsState = {
  data: { next: '', positions: [], prev: '' },
  fetching: false,
  hasError: false
}

const positionsSlice = createSlice({
  initialState,
  name: 'positions',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    fetchNext(state) {
      state.fetching = true
    },
    loading(state) {
      state.fetching = true
    },
    reset() {
      return initialState
    },
    setData(state, action: PayloadAction<PositionHistoryData>) {
      state.fetching = false
      state.data.positions = [...state.data.positions, ...action.payload.positions]
      state.data.next = action.payload.next
    }
  }
})

export const { actions } = positionsSlice
export default positionsSlice.reducer
